var map = {
	"./auth/auth.module": [
		"./src/app/content/pages/auth/auth.module.ts",
		"auth-auth-module"
	],
	"./builder/builder.module": [
		"./src/app/content/pages/builder/builder.module.ts",
		"builder-builder-module"
	],
	"app/content/pages/pages.module": [
		"./src/app/content/pages/pages.module.ts",
		"app-content-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;